<h2 mat-dialog-title>{{ mode === 'update' ? 'Update' : 'Add' }} Item</h2>
<div mat-dialog-content>
  <form [formGroup]="form">
    <div *ngFor="let field of fields">
      <div *ngIf="!field.hiddenDialog">
        <ng-container *ngIf="(field.type !== 'dropdown')">
          <mat-form-field appearance="outline" class="full-width" style="margin-top: 20px;">
            <mat-label>{{field.displayName}}</mat-label>
            <input matInput [formControlName]="field.key" />
          </mat-form-field>
        </ng-container>
        <ng-container *ngIf="(field.type === 'dropdown')">
          <label for={{field.key}}>{{field.displayName}}</label>
          <select formControlName={{field.key}} id={{field.key}} class="form-control">
            <option value="" disabled selected>Select a {{field.displayName}}</option>
            <option *ngFor="let option of field.options" [value]="option.value">{{ option.label }}</option>
          </select>
        </ng-container>

      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button (click)="onSubmit()" [disabled]="form.invalid">{{ mode === 'update' ? 'Update' : 'Add' }}</button>
</div>